import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import { SkywalkerWeb } from '@growth/skywalker/entries/cabs-dweb-home';
import PopularCarRoutes from '../../../../../stories/components/cars/homepage/PopularCarRoutes/PopularCarRoutesUI';
import HomeBookingFaq from '../../../../../stories/components/cars/homepage/HomeFaq/HomeFaqUI';
import HomeDesc from '../../../../../stories/components/cars/homepage/HomeDesc/HomeDescUI';
import { faqSelector, popularRoutesSelector,contentSelector } from '../../redux/selector';
import { cabsFaqDataSelector, oneWayCabInterlinksSelector, oneWayCabSelector, tripTypeSelector } from '../../../../common/redux/selector';
import Interlinking from "../../../../../stories/components/cars/homepage/Interlinking/Interlinking";
import OneWayInterlinking from "../../../../../stories/components/cars/homepage/Interlinking/OneWayInterlinking";
import { topRoutes, topCityFrom, topCityTo, topAirportRoutes, ONE_WAY_CAB } from "../../../../config/constants";
import { SEO_ROUTE_STATIC_CONTENT } from "../../../../config/constants";
import { getLoadedComponent } from "../../../../../shared/config/omni";
import { skyWalkerStyle } from "./HomeFooter.styles";

const HomeFooter = () => {
  const tripType = useSelector(tripTypeSelector);
  const faqData = useSelector(faqSelector);
  const popularRoutes = useSelector(popularRoutesSelector);
  const contentData = useSelector(contentSelector)
  const isOneWayCab = useSelector(oneWayCabSelector)
  const linkingData = useSelector(oneWayCabInterlinksSelector)
  const cabFaqData = useSelector(cabsFaqDataSelector)
   
  useEffect(() => {
    getLoadedComponent('HomeFooter')
  }, [])

  return (
    <>
      <SkywalkerWeb lobName="cab" page="CabsHome" errorCardStyle={skyWalkerStyle} pdtInstance={{track: (eventName, obj) => {}}}/>
      <PopularCarRoutes popularRoutes={popularRoutes} />
      <HomeDesc content={contentData || SEO_ROUTE_STATIC_CONTENT} />
      <HomeBookingFaq faqData={faqData} rf={isOneWayCab ? ONE_WAY_CAB : tripType?.rf} cabsFaqData={cabFaqData}/>
      {
        isOneWayCab
        ? <OneWayInterlinking interLinks={linkingData} /> 
        : <Interlinking topRoutes={topRoutes} cityFrom={topCityFrom} cityTo={topCityTo} airportRoutes={topAirportRoutes} />
      }
    </>
  );
}

export default React.memo(HomeFooter);

